import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState, useEffect } from 'react'
import useApi from '../../api';
import { RadioGroup } from '@headlessui/react'
import { DocumentationInterface } from '../../types';
import { set } from 'lodash';
import { conLog } from '../../utils/conLog';


export default function SelectDocument({ doc, setDocument } : { doc: any, setDocument: any }) {
  let [isOpen, setIsOpen] = useState(false)
  const [documents, setDocuments] = useState([])
  const [selected, setSelected] = useState<DocumentationInterface | undefined>(doc)
  const { get, getStream, post, postStream, put, patch, remove } = useApi();


  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  function selectDoc(document: any) {
    setDocument(document)
    setSelected(document)
    setIsOpen(false)
  }

  function Documents({ documents } : { documents: any }) {

    return (
      <div className="w-full px-4 overflow-y-auto max-h-96 py-2">
        <div className="mx-auto w-full max-w-2xl">
          <RadioGroup value={selected} onChange={(doc) => selectDoc(doc)}>
            <div className="space-y-2">
              {documents.map((document: any) => (
                <RadioGroup.Option
                  key={document.name}
                  value={document}
                  className={({ active, checked }) =>
                    `${
                      active
                        ? 'ring-2 ring-white/60 ring-offset-2 ring-offset-sky-300'
                        : ''
                    }
                    ${checked ? 'bg-slate-300/75 text-white' : 'bg-white'}
                      border border-slate-200 shadow-sm relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none dark:bg-slate-700 dark:border dark:border-slate-200 hover:bg-slate-50 transition duration-200`
                  }
                >
                  {({ active, checked }) => (
                    <>
                      <div className="flex w-full items-center justify-between">
                        <div className="flex items-center">
                          <div className="text-sm">
                            <RadioGroup.Label
                              as="p"
                              className={`font-medium  ${
                                checked ? 'text-white' : 'text-slate-900 dark:text-slate-200'
                              }`}
                            >
                              {document.name}
                            </RadioGroup.Label>
                            <RadioGroup.Description
                              as="span"
                              className={`inline ${
                                checked ? 'text-sky-100' : 'text-slate-500 dark:text-slate-300'
                              }`}
                            >
                              <span>
                                {document.description}
                              </span>
                            </RadioGroup.Description>
                          </div>
                        </div>
                        {checked && (
                          <div className="shrink-0 text-white">
                            <CheckIcon className="h-6 w-6" />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>
      </div>
    )
  }
  
  function CheckIcon(props: any) {
    return (
      <svg viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
        <path
          d="M7 13l3 3 7-7"
          stroke="#fff"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  useEffect(() => {
    if (!isOpen) return
    get('/documentation/').then((response) => {
      conLog(response.data)
      setDocuments(response.data.filter((doc: any) => doc.type === 'document'))
    })
  }, [isOpen])

  const handleClear = () => {
    setSelected(undefined)
    setDocument(undefined)
  };

  return (
    <>
    {selected && (
        <div className="mb-6">
        <div className="p-4 border shadow-sm bg-slate-50 rounded-lg w-1/2 mt-3 dark:bg-slate-700 dark:border-none">
          <div className="flex flex-row justify-between">
            <p onClick={() => openModal()} className="text-md font-medium text-slate-900 hover:cursor-pointer dark:text-slate-300">{selected.name}</p>
            <div onClick={() => handleClear()}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 stroke-slate-500 hover:stroke-slate-800 dark:stroke-slate-400">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
          </div>
           </div> 
            <p className="text-sm text-slate-500 dark:text-slate-400">{selected.description}</p>
        </div>
        </div>
    )}
    
    {!selected && (
        <div className="mt-2">
        <button
            type="button"
            className="inline-flex justify-center rounded-md border border-transparent bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:bg-slate-600 dark:text-slate-50 dark:hover:bg-slate-600/50"
            onClick={openModal}
            >
            Select Document
        </button>
    </div>
    )}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-slate-800">
                  <Dialog.Title
                    as="h3"
                    className="text-xl text-center font-medium leading-6 text-slate-900 mb-4 dark:text-slate-50"
                  >
                    Select Document
                  </Dialog.Title>
                  {documents && (
                    <Documents documents={documents} />
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
